// 簡易ハッシュルーティング（§3.1: 計算 / 測定 / 比較 / 解説 の4ビュー）。
export type Route = 'calc' | 'measure' | 'compare' | 'explain';

const ROUTES: Route[] = ['calc', 'measure', 'compare', 'explain'];

export function parseRoute(hash: string): Route {
  const h = hash.replace(/^#\/?/, '').split('/')[0] ?? '';
  return (ROUTES as string[]).includes(h) ? (h as Route) : 'calc';
}

export function currentRoute(): Route {
  return parseRoute(location.hash);
}

export function navigate(route: Route): void {
  location.hash = `#/${route}`;
}

export function onRouteChange(fn: (r: Route) => void): () => void {
  const handler = () => fn(currentRoute());
  window.addEventListener('hashchange', handler);
  return () => window.removeEventListener('hashchange', handler);
}
